import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { AdminRequestsSections } from './enums';
import { MembersPageType } from 'features/admin/member/enums';
import ClientRequestsSection from 'features/client/ClientRequestsSection';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import MemberRequestsSection from 'features/admin/member/AdminMembersSection';
import AssignmentRequestsSection from 'features/assignment/AssignmentRequestsSection';
import DuplicateWorkersSection from 'features/worker/WorkersPage/DuplicateWorkersSection';
import useQueryMatch from 'hooks/useQueryMatch';
import { useAppSelector } from 'hooks/useAppSelector';

const DEFAULT_SECTION = AdminRequestsSections.Members;
const PAGE_SECTIONS = Object.values(AdminRequestsSections);

export default function RequestsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useAppSelector(isAdminSelector);
  const query = queryString.parse(location.search);
  const pageSectionMatch = useQueryMatch(PAGE_SECTIONS);

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${DEFAULT_SECTION}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getSection = () => {
    switch (query.section) {
      case AdminRequestsSections.Clients:
        return (
          <ClientRequestsSection isAdmin={isAdmin} includeInProgress={true} />
        );

      case AdminRequestsSections.Assignments:
        return <AssignmentRequestsSection isAdmin={isAdmin} />;

      case AdminRequestsSections.Workers:
        return <DuplicateWorkersSection />;

      case AdminRequestsSections.Members:
      default:
        return <MemberRequestsSection pageType={MembersPageType.Requests} />;
    }
  };

  return <>{getSection()}</>;
}
